import {
  Box,
  CloseRoundedIcon,
  Divider,
  Flex,
  IconButton,
  Popover,
  Text,
} from '@shared/components';

interface QBankStructureLevelPopoverProps {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
  children?: React.ReactNode;
}

export default function QBankStructureLevelPopover(
  props: Readonly<QBankStructureLevelPopoverProps>,
) {
  const { anchorEl, children, open: isOpen, onClose } = props;
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{ '& .MuiPaper-root': { width: 480 } }}
    >
      <Flex sx={{ flexDirection: 'column' }}>
        <Flex
          sx={{
            p: (theme) => theme.spacing(6),
            justifyContent: 'space-between',
            position: 'relative',
          }}
        >
          <Text variant='h3'>ตั้งค่าระดับโครงสร้าง</Text>
          <IconButton onClick={onClose} sx={{ position: 'absolute', top: 16, right: 16 }}>
            <CloseRoundedIcon sx={{ width: '24px', height: '24px' }} />
          </IconButton>
        </Flex>
        <Divider />
        <Box>{children}</Box>
      </Flex>
    </Popover>
  );
}
